import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components'
import { Modal, Typo } from '../../../ui';
import { useEditableCourses } from '../../courses/hooks';
import { useTeachers } from '../../users/hooks/useUsersState';
import { useUsersActions } from '../../users/hooks/useUsersActions';
import SearchSelect from '../../../ui/SearchSelect';
import { useTranslation } from 'react-i18next';

const Wrapper = styled.div`
  padding: 1rem 0;
`

const InviteTeacher = ({ isModalOpen, closeModal }) => {
  const { t } = useTranslation();

  const { courses = [] } = useEditableCourses(
    { searchText: '', showUncorrected: false },
    { skip: !isModalOpen }
  );
  const { teachers: users = [] } = useTeachers();
  const { addUserToCourse } = useUsersActions();

  const [contentValid, setContentValid] = useState(false);
  const [course, setCourse] = useState(null)
  const [user, setUser] = useState(null)


  useEffect(() => {
    const isValid = Boolean(user && course);
    setContentValid(isValid);
  }, [user, course])

  const clearState = useCallback(() => {
    setCourse(null)
    setUser(null)
    setContentValid(false)
  }, [])

  const closeDialog = useCallback(() => {
    closeModal()
    clearState();
  }, [clearState, closeModal])

  const addTeacherToCourse = useCallback(async () => {
    const courseId = course?.id
    const userId = user.id
    const role = 'builder'

    await addUserToCourse({ userId, courseId, role });
    closeDialog();
  }, [addUserToCourse, closeDialog, course, user])

  return (
    <Modal
      title={t('invites.addTeacher')}
      onClose={closeDialog}
      onAccept={addTeacherToCourse}
      showActions
      open={isModalOpen}
      acceptLabel={t('globals.send')}
      acceptIsDisabled={!contentValid}
    >
      <>
        <Wrapper>
          <Typo.SmallText>{t('invites.selectTeacher')}</Typo.SmallText>
          <SearchSelect
            setValue={setUser}
            selectedOptions={user}
            id='users'
            options={Array.isArray(users) ? users : []}
            renderOption={(props, option) => {
              return <li {...props} key={option.id || option}>
                <div >
                  <Typo.Text >{option.name}</Typo.Text>
                  <Typo.Info >{option.email}</Typo.Info>
                </div>
              </li>
            }}
          />

        </Wrapper>
        <Wrapper>
          <Typo.Text>{t('invites.teacherAccessInfo')}</Typo.Text>
          <SearchSelect
            setValue={setCourse}
            selectedOptions={course}
            id='courses'
            label={t('invites.courseInstruction')}
            options={courses.map((item) => ({ name: `${item.name} (${item.id})`, id: item.id }))}
          />
        </Wrapper>
      </>
    </Modal>
  );
}

export default InviteTeacher;
